const ADD_TO_CART = "ADD_TO_CART";
const REMOVE_FROM_CART = "REMOVE_FROM_CART";
const INCREASE_CART_ITEM = "INCREASE_CART_ITEM";
const DECREASE_CART_ITEM = "DECREASE_CART_ITEM";
const GET_TOTALS = "GET_TOTALS";
const MOVE_TO_CART = "MOVE_TO_CART";
const REMOVE_MODAL = "REMOVE_MODAL";
const PAYMENT_DONE = "PAYMENT_DONE";

export {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  INCREASE_CART_ITEM,
  DECREASE_CART_ITEM,
  GET_TOTALS,
  MOVE_TO_CART,
  REMOVE_MODAL,
  PAYMENT_DONE,
};
